import {
  KProperty02ce7r476m8633 as KProperty0,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
} from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { DecimalFraction15n0off36xuu9 as DecimalFraction } from '../internal/math.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { DateTimeFormatException2onfeknbywaob as DateTimeFormatException } from '../Exceptions.mjs';
import { requireParsedField387b2jr94jy2p as requireParsedField } from './LocalDateFormat.mjs';
import { LocalTime22kisvxz6f9p4 as LocalTime } from '../LocalTime.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { padStart36w1507hs626a as padStart } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { AppendableFormatStructure38mt32f1b8qva as AppendableFormatStructure } from '../internal/format/Builder.mjs';
import {
  appendAlternativeParsingImpl1mug8j87kp2j3 as appendAlternativeParsingImpl,
  appendOptionalImplcg29ds00y54b as appendOptionalImpl,
  chars1g48a4lypizqb as chars,
  build284bs2tzkjm2x as build,
  hour$default28zjolx0s9fg0 as hour$default,
  minute$defaultoouhhkuji8pa as minute$default,
  second$default25cj8g9tgx4nm as second$default,
  AbstractDateTimeFormatBuilder2kkelk07l4wb as AbstractDateTimeFormatBuilder,
  WithTime2lgb7k6hqa1zi as WithTime,
  char1r4ssccmdfesy as char,
  alternativeParsing1gmwubnsvpp9b as alternativeParsing,
  optional3j6ywsx1pxeh6 as optional,
} from './DateTimeFormatBuilder.mjs';
import {
  AbstractDateTimeFormat1er9ki1vjeb1b as AbstractDateTimeFormat,
  Padding_ZERO_getInstance2hdjif6phlc74 as Padding_ZERO_getInstance,
  Padding_SPACE_getInstance7fwkzb4da6c as Padding_SPACE_getInstance,
} from './DateTimeFormat.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { BasicFormatStructure1rp1tyv3u2fjw as BasicFormatStructure } from '../internal/format/FormatStructure.mjs';
import {
  UnsignedIntFieldFormatDirective20kfpdbszyixg as UnsignedIntFieldFormatDirective,
  NamedEnumIntFieldFormatDirective2e2bgf4uj6a33 as NamedEnumIntFieldFormatDirective,
  DecimalFractionFieldFormatDirective1h9sbm886izzq as DecimalFractionFieldFormatDirective,
} from '../internal/format/FieldFormatDirective.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  PropertyAccessor1m9zk65ebkfc4 as PropertyAccessor,
  UnsignedFieldSpec1pqzij1hidkca as UnsignedFieldSpec,
  GenericFieldSpecnllvuuqbuxsd as GenericFieldSpec,
} from '../internal/format/FieldSpec.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_ISO_TIME() {
  _init_properties_LocalTimeFormat_kt__5i3lfh();
  var tmp0 = ISO_TIME$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('ISO_TIME', 0, tmp, _get_ISO_TIME_$ref_kyx2od(), null);
  return tmp0.f2();
}
var ISO_TIME$delegate;
function get_emptyIncompleteLocalTime() {
  _init_properties_LocalTimeFormat_kt__5i3lfh();
  return emptyIncompleteLocalTime;
}
var emptyIncompleteLocalTime;
function set_fractionOfSecond(value) {
  this.f1q(value == null ? null : value.y1w(9));
}
function get_fractionOfSecond() {
  var tmp0_safe_receiver = this.a1p();
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = new (DecimalFraction())(tmp0_safe_receiver, 9);
  }
  return tmp;
}
var TimeFieldContainerClass;
function TimeFieldContainer() {
  if (TimeFieldContainerClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'TimeFieldContainer');
    TimeFieldContainerClass = $;
  }
  return TimeFieldContainerClass;
}
var IncompleteLocalTimeClass;
function IncompleteLocalTime() {
  if (IncompleteLocalTimeClass === VOID) {
    class $ {
      constructor(hour, hourOfAmPm, amPm, minute, second, nanosecond) {
        hour = hour === VOID ? null : hour;
        hourOfAmPm = hourOfAmPm === VOID ? null : hourOfAmPm;
        amPm = amPm === VOID ? null : amPm;
        minute = minute === VOID ? null : minute;
        second = second === VOID ? null : second;
        nanosecond = nanosecond === VOID ? null : nanosecond;
        this.s1p_1 = hour;
        this.t1p_1 = hourOfAmPm;
        this.u1p_1 = amPm;
        this.v1p_1 = minute;
        this.w1p_1 = second;
        this.x1p_1 = nanosecond;
      }
      b1q(_set____db54di) {
        this.s1p_1 = _set____db54di;
      }
      x1o() {
        return this.s1p_1;
      }
      c1q(_set____db54di) {
        this.t1p_1 = _set____db54di;
      }
      d1q() {
        return this.t1p_1;
      }
      r1p(_set____db54di) {
        this.u1p_1 = _set____db54di;
      }
      y1p() {
        return this.u1p_1;
      }
      e1q(_set____db54di) {
        this.v1p_1 = _set____db54di;
      }
      y1o() {
        return this.v1p_1;
      }
      g1q(_set____db54di) {
        this.w1p_1 = _set____db54di;
      }
      z1o() {
        return this.w1p_1;
      }
      f1q(_set____db54di) {
        this.x1p_1 = _set____db54di;
      }
      a1p() {
        return this.x1p_1;
      }
      e1s() {
        var tmp0_safe_receiver = this.s1p_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp0_safe_receiver_0 = this.t1p_1;
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.require' call
            if (!((((tmp0_safe_receiver + 11 | 0) % 12 | 0) + 1 | 0) === tmp0_safe_receiver_0)) {
              var message = 'Inconsistent hour and hour-of-am-pm: hour is ' + tmp0_safe_receiver + ', but hour-of-am-pm is ' + tmp0_safe_receiver_0;
              throw IllegalArgumentException().a1(toString(message));
            }
          }
          var tmp1_safe_receiver = this.u1p_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.require' call
            if (!(tmp1_safe_receiver.equals(AmPmMarker_PM_getInstance()) === tmp0_safe_receiver >= 12)) {
              var message_0 = 'Inconsistent hour and the AM/PM marker: hour is ' + tmp0_safe_receiver + ', but the AM/PM marker is ' + tmp1_safe_receiver.toString();
              throw IllegalArgumentException().a1(toString(message_0));
            }
          }
          tmp = tmp0_safe_receiver;
        }
        var tmp2_elvis_lhs = tmp;
        var tmp_0;
        if (tmp2_elvis_lhs == null) {
          var tmp1_safe_receiver_0 = this.t1p_1;
          var tmp_1;
          if (tmp1_safe_receiver_0 == null) {
            tmp_1 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp0_safe_receiver_1 = this.u1p_1;
            var tmp_2;
            if (tmp0_safe_receiver_1 == null) {
              tmp_2 = null;
            } else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.let' call
              tmp_2 = (tmp1_safe_receiver_0 === 12 ? 0 : tmp1_safe_receiver_0) + (tmp0_safe_receiver_1.equals(AmPmMarker_PM_getInstance()) ? 12 : 0) | 0;
            }
            tmp_1 = tmp_2;
          }
          tmp_0 = tmp_1;
        } else {
          tmp_0 = tmp2_elvis_lhs;
        }
        var tmp3_elvis_lhs = tmp_0;
        var tmp_3;
        if (tmp3_elvis_lhs == null) {
          throw DateTimeFormatException().y1m('Incomplete time: missing hour');
        } else {
          tmp_3 = tmp3_elvis_lhs;
        }
        var hour = tmp_3;
        var tmp_4 = requireParsedField(this.v1p_1, 'minute');
        var tmp4_elvis_lhs = this.w1p_1;
        var tmp_5 = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
        var tmp5_elvis_lhs = this.x1p_1;
        return LocalTime().z1w(hour, tmp_4, tmp_5, tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs);
      }
      v1w(localTime) {
        this.s1p_1 = localTime.x1o();
        this.t1p_1 = ((localTime.x1o() + 11 | 0) % 12 | 0) + 1 | 0;
        this.u1p_1 = localTime.x1o() >= 12 ? AmPmMarker_PM_getInstance() : AmPmMarker_AM_getInstance();
        this.v1p_1 = localTime.y1o();
        this.w1p_1 = localTime.z1o();
        this.x1p_1 = localTime.a1p();
      }
      t1q() {
        return new (IncompleteLocalTime())(this.s1p_1, this.t1p_1, this.u1p_1, this.v1p_1, this.w1p_1, this.x1p_1);
      }
      equals(other) {
        var tmp;
        var tmp_0;
        var tmp_1;
        var tmp_2;
        var tmp_3;
        var tmp_4;
        if (other instanceof IncompleteLocalTime()) {
          tmp_4 = this.s1p_1 == other.s1p_1;
        } else {
          tmp_4 = false;
        }
        if (tmp_4) {
          tmp_3 = this.t1p_1 == other.t1p_1;
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          tmp_2 = equals(this.u1p_1, other.u1p_1);
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp_1 = this.v1p_1 == other.v1p_1;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = this.w1p_1 == other.w1p_1;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = this.x1p_1 == other.x1p_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        var tmp6_elvis_lhs = this.s1p_1;
        var tmp = imul(tmp6_elvis_lhs == null ? 0 : tmp6_elvis_lhs, 31);
        var tmp5_elvis_lhs = this.t1p_1;
        var tmp_0 = tmp + imul(tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs, 31) | 0;
        var tmp3_safe_receiver = this.u1p_1;
        var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.hashCode();
        var tmp_1 = tmp_0 + imul(tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs, 31) | 0;
        var tmp2_elvis_lhs = this.v1p_1;
        var tmp_2 = tmp_1 + imul(tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs, 31) | 0;
        var tmp1_elvis_lhs = this.w1p_1;
        var tmp_3 = tmp_2 + imul(tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs, 31) | 0;
        var tmp0_elvis_lhs = this.x1p_1;
        return tmp_3 + (tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs) | 0;
      }
      toString() {
        var tmp0_elvis_lhs = this.s1p_1;
        var tmp = toString(tmp0_elvis_lhs == null ? '??' : tmp0_elvis_lhs);
        var tmp1_elvis_lhs = this.v1p_1;
        var tmp_0 = toString(tmp1_elvis_lhs == null ? '??' : tmp1_elvis_lhs);
        var tmp2_elvis_lhs = this.w1p_1;
        var tmp_1 = toString(tmp2_elvis_lhs == null ? '??' : tmp2_elvis_lhs);
        var tmp3_safe_receiver = this.x1p_1;
        var tmp_2;
        if (tmp3_safe_receiver == null) {
          tmp_2 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.let' call
          var it = tmp3_safe_receiver.toString();
          tmp_2 = padStart(it, 9 - it.length | 0, _Char___init__impl__6a9atx(48));
        }
        var tmp4_elvis_lhs = tmp_2;
        return tmp + ':' + tmp_0 + ':' + tmp_1 + '.' + (tmp4_elvis_lhs == null ? '???' : tmp4_elvis_lhs);
      }
    }
    protoOf($).z1p = set_fractionOfSecond;
    protoOf($).a1q = get_fractionOfSecond;
    initMetadataForClass($, 'IncompleteLocalTime', IncompleteLocalTime, VOID, [TimeFieldContainer()]);
    IncompleteLocalTimeClass = $;
  }
  return IncompleteLocalTimeClass;
}
var AmPmMarker_AM_instance;
var AmPmMarker_PM_instance;
var AmPmMarker_entriesInitialized;
function AmPmMarker_initEntries() {
  if (AmPmMarker_entriesInitialized)
    return Unit_instance;
  AmPmMarker_entriesInitialized = true;
  AmPmMarker_AM_instance = AmPmMarker().c1x('AM', 0);
  AmPmMarker_PM_instance = AmPmMarker().c1x('PM', 1);
}
var AmPmMarkerClass;
function AmPmMarker() {
  if (AmPmMarkerClass === VOID) {
    class $ extends Enum() {
      static c1x(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'AmPmMarker');
    AmPmMarkerClass = $;
  }
  return AmPmMarkerClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      d1x(block) {
        var builder = new (Builder())(new (AppendableFormatStructure())());
        block(builder);
        return new (LocalTimeFormat())(builder.m1r());
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(actualBuilder) {
        this.e1x_1 = actualBuilder;
      }
      o1s() {
        return this.e1x_1;
      }
      x1s(structure) {
        this.e1x_1.r1s(structure);
      }
      t1s() {
        return new (Builder())(new (AppendableFormatStructure())());
      }
    }
    protoOf($).u1s = appendAlternativeParsingImpl;
    protoOf($).v1s = appendOptionalImpl;
    protoOf($).g1r = chars;
    protoOf($).m1r = build;
    protoOf($).c1t = hour;
    protoOf($).v1q = hour$default;
    protoOf($).d1t = amPmHour;
    protoOf($).e1t = amPmMarker;
    protoOf($).f1t = minute;
    protoOf($).w1q = minute$default;
    protoOf($).g1t = second;
    protoOf($).x1q = second$default;
    protoOf($).y1q = secondFraction;
    protoOf($).h1t = time;
    initMetadataForClass($, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder(), AbstractWithTimeBuilder()]);
    BuilderClass = $;
  }
  return BuilderClass;
}
var LocalTimeFormatClass;
function LocalTimeFormat() {
  if (LocalTimeFormatClass === VOID) {
    class $ extends AbstractDateTimeFormat() {
      constructor(actualFormat) {
        super();
        this.f1x_1 = actualFormat;
      }
      o1t() {
        return this.f1x_1;
      }
      g1x(value) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (IncompleteLocalTime())();
        this_0.v1w(value);
        return this_0;
      }
      q1t(value) {
        return this.g1x(value instanceof LocalTime() ? value : THROW_CCE());
      }
      h1x(intermediate) {
        return intermediate.e1s();
      }
      s1t(intermediate) {
        return this.h1x(intermediate instanceof IncompleteLocalTime() ? intermediate : THROW_CCE());
      }
      t1t() {
        return get_emptyIncompleteLocalTime();
      }
    }
    initMetadataForClass($, 'LocalTimeFormat');
    LocalTimeFormatClass = $;
  }
  return LocalTimeFormatClass;
}
function hour(padding) {
  return this.x1s(new (BasicFormatStructure())(new (HourDirective())(padding)));
}
function amPmHour(padding) {
  return this.x1s(new (BasicFormatStructure())(new (AmPmHourDirective())(padding)));
}
function amPmMarker(am, pm) {
  return this.x1s(new (BasicFormatStructure())(new (AmPmMarkerDirective())(am, pm)));
}
function minute(padding) {
  return this.x1s(new (BasicFormatStructure())(new (MinuteDirective())(padding)));
}
function second(padding) {
  return this.x1s(new (BasicFormatStructure())(new (SecondDirective())(padding)));
}
function secondFraction(minLength, maxLength) {
  return this.x1s(new (BasicFormatStructure())(new (FractionalSecondDirective())(minLength, maxLength)));
}
function time(format) {
  var tmp;
  if (format instanceof LocalTimeFormat()) {
    this.x1s(format.f1x_1);
    tmp = Unit_instance;
  }
  return tmp;
}
var AbstractWithTimeBuilderClass;
function AbstractWithTimeBuilder() {
  if (AbstractWithTimeBuilderClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'AbstractWithTimeBuilder', VOID, VOID, [WithTime()]);
    AbstractWithTimeBuilderClass = $;
  }
  return AbstractWithTimeBuilderClass;
}
var HourDirectiveClass;
function HourDirective() {
  if (HourDirectiveClass === VOID) {
    class $ extends UnsignedIntFieldFormatDirective() {
      constructor(padding) {
        var tmp = TimeFields_getInstance().i1x_1;
        // Inline function 'kotlinx.datetime.format.minDigits' call
        var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
        // Inline function 'kotlinx.datetime.format.spaces' call
        super(tmp, tmp_0, padding.equals(Padding_SPACE_getInstance()) ? 2 : null);
        this.s1x_1 = padding;
      }
      equals(other) {
        var tmp;
        if (other instanceof HourDirective()) {
          tmp = this.s1x_1.equals(other.s1x_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.s1x_1.hashCode();
      }
    }
    initMetadataForClass($, 'HourDirective');
    HourDirectiveClass = $;
  }
  return HourDirectiveClass;
}
var AmPmHourDirectiveClass;
function AmPmHourDirective() {
  if (AmPmHourDirectiveClass === VOID) {
    class $ extends UnsignedIntFieldFormatDirective() {
      constructor(padding) {
        var tmp = TimeFields_getInstance().n1x_1;
        // Inline function 'kotlinx.datetime.format.minDigits' call
        var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
        // Inline function 'kotlinx.datetime.format.spaces' call
        super(tmp, tmp_0, padding.equals(Padding_SPACE_getInstance()) ? 2 : null);
        this.x1x_1 = padding;
      }
      equals(other) {
        var tmp;
        if (other instanceof AmPmHourDirective()) {
          tmp = this.x1x_1.equals(other.x1x_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.x1x_1.hashCode();
      }
    }
    initMetadataForClass($, 'AmPmHourDirective');
    AmPmHourDirectiveClass = $;
  }
  return AmPmHourDirectiveClass;
}
var AmPmMarkerDirectiveClass;
function AmPmMarkerDirective() {
  if (AmPmMarkerDirectiveClass === VOID) {
    class $ extends NamedEnumIntFieldFormatDirective() {
      constructor(amString, pmString) {
        super(TimeFields_getInstance().m1x_1, mapOf([to(AmPmMarker_AM_getInstance(), amString), to(AmPmMarker_PM_getInstance(), pmString)]), 'AM/PM marker');
        this.c1y_1 = amString;
        this.d1y_1 = pmString;
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (other instanceof AmPmMarkerDirective()) {
          tmp_0 = this.c1y_1 === other.c1y_1;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = this.d1y_1 === other.d1y_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return imul(31, getStringHashCode(this.c1y_1)) + getStringHashCode(this.d1y_1) | 0;
      }
    }
    initMetadataForClass($, 'AmPmMarkerDirective');
    AmPmMarkerDirectiveClass = $;
  }
  return AmPmMarkerDirectiveClass;
}
var MinuteDirectiveClass;
function MinuteDirective() {
  if (MinuteDirectiveClass === VOID) {
    class $ extends UnsignedIntFieldFormatDirective() {
      constructor(padding) {
        var tmp = TimeFields_getInstance().j1x_1;
        // Inline function 'kotlinx.datetime.format.minDigits' call
        var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
        // Inline function 'kotlinx.datetime.format.spaces' call
        super(tmp, tmp_0, padding.equals(Padding_SPACE_getInstance()) ? 2 : null);
        this.m1y_1 = padding;
      }
      equals(other) {
        var tmp;
        if (other instanceof MinuteDirective()) {
          tmp = this.m1y_1.equals(other.m1y_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.m1y_1.hashCode();
      }
    }
    initMetadataForClass($, 'MinuteDirective');
    MinuteDirectiveClass = $;
  }
  return MinuteDirectiveClass;
}
var SecondDirectiveClass;
function SecondDirective() {
  if (SecondDirectiveClass === VOID) {
    class $ extends UnsignedIntFieldFormatDirective() {
      constructor(padding) {
        var tmp = TimeFields_getInstance().k1x_1;
        // Inline function 'kotlinx.datetime.format.minDigits' call
        var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
        // Inline function 'kotlinx.datetime.format.spaces' call
        super(tmp, tmp_0, padding.equals(Padding_SPACE_getInstance()) ? 2 : null);
        this.r1y_1 = padding;
      }
      equals(other) {
        var tmp;
        if (other instanceof SecondDirective()) {
          tmp = this.r1y_1.equals(other.r1y_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.r1y_1.hashCode();
      }
    }
    initMetadataForClass($, 'SecondDirective');
    SecondDirectiveClass = $;
  }
  return SecondDirectiveClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.s1y_1 = listOf([0, 0, 0, 0, 0, 0, 0, 0, 0]);
        this.t1y_1 = listOf([2, 1, 0, 2, 1, 0, 2, 1, 0]);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var FractionalSecondDirectiveClass;
function FractionalSecondDirective() {
  if (FractionalSecondDirectiveClass === VOID) {
    class $ extends DecimalFractionFieldFormatDirective() {
      constructor(minDigits, maxDigits, zerosToAdd) {
        Companion_getInstance_0();
        zerosToAdd = zerosToAdd === VOID ? Companion_getInstance_0().s1y_1 : zerosToAdd;
        super(TimeFields_getInstance().l1x_1, minDigits, maxDigits, zerosToAdd);
        this.y1y_1 = minDigits;
        this.z1y_1 = maxDigits;
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (other instanceof FractionalSecondDirective()) {
          tmp_0 = this.y1y_1 === other.y1y_1;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = this.z1y_1 === other.z1y_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return imul(31, this.y1y_1) + this.z1y_1 | 0;
      }
    }
    initMetadataForClass($, 'FractionalSecondDirective');
    FractionalSecondDirectiveClass = $;
  }
  return FractionalSecondDirectiveClass;
}
function TimeFieldContainer$_get_hour_$ref_8ezbwm() {
  return (p0) => p0.x1o();
}
function TimeFieldContainer$_set_hour_$ref_l7vnde() {
  return (p0, p1) => {
    p0.b1q(p1);
    return Unit_instance;
  };
}
function TimeFieldContainer$_get_minute_$ref_evb2i2() {
  return (p0) => p0.y1o();
}
function TimeFieldContainer$_set_minute_$ref_6xin6() {
  return (p0, p1) => {
    p0.e1q(p1);
    return Unit_instance;
  };
}
function TimeFieldContainer$_get_second_$ref_t7tjxy() {
  return (p0) => p0.z1o();
}
function TimeFieldContainer$_set_second_$ref_qr1wvy() {
  return (p0, p1) => {
    p0.g1q(p1);
    return Unit_instance;
  };
}
function TimeFieldContainer$_get_fractionOfSecond_$ref_u85by5() {
  return (p0) => p0.a1q();
}
function TimeFieldContainer$_set_fractionOfSecond_$ref_quw20n() {
  return (p0, p1) => {
    p0.z1p(p1);
    return Unit_instance;
  };
}
function TimeFieldContainer$_get_amPm_$ref_u9tt1b() {
  return (p0) => p0.y1p();
}
function TimeFieldContainer$_set_amPm_$ref_hgxhkj() {
  return (p0, p1) => {
    p0.r1p(p1);
    return Unit_instance;
  };
}
function TimeFieldContainer$_get_hourOfAmPm_$ref_okyxye() {
  return (p0) => p0.d1q();
}
function TimeFieldContainer$_set_hourOfAmPm_$ref_y4i32() {
  return (p0, p1) => {
    p0.c1q(p1);
    return Unit_instance;
  };
}
var TimeFieldsClass;
function TimeFields() {
  if (TimeFieldsClass === VOID) {
    class $ {
      constructor() {
        TimeFields_instance = this;
        var tmp = this;
        var tmp_0 = KMutableProperty1();
        var tmp_1 = TimeFieldContainer$_get_hour_$ref_8ezbwm();
        tmp.i1x_1 = new (UnsignedFieldSpec())(new (PropertyAccessor())(getPropertyCallableRef('hour', 1, tmp_0, tmp_1, TimeFieldContainer$_set_hour_$ref_l7vnde())), 0, 23);
        var tmp_2 = this;
        var tmp_3 = KMutableProperty1();
        var tmp_4 = TimeFieldContainer$_get_minute_$ref_evb2i2();
        tmp_2.j1x_1 = new (UnsignedFieldSpec())(new (PropertyAccessor())(getPropertyCallableRef('minute', 1, tmp_3, tmp_4, TimeFieldContainer$_set_minute_$ref_6xin6())), 0, 59);
        var tmp_5 = this;
        var tmp_6 = KMutableProperty1();
        var tmp_7 = TimeFieldContainer$_get_second_$ref_t7tjxy();
        tmp_5.k1x_1 = new (UnsignedFieldSpec())(new (PropertyAccessor())(getPropertyCallableRef('second', 1, tmp_6, tmp_7, TimeFieldContainer$_set_second_$ref_qr1wvy())), 0, 59, VOID, 0);
        var tmp_8 = this;
        var tmp_9 = KMutableProperty1();
        var tmp_10 = TimeFieldContainer$_get_fractionOfSecond_$ref_u85by5();
        tmp_8.l1x_1 = new (GenericFieldSpec())(new (PropertyAccessor())(getPropertyCallableRef('fractionOfSecond', 1, tmp_9, tmp_10, TimeFieldContainer$_set_fractionOfSecond_$ref_quw20n())), VOID, new (DecimalFraction())(0, 9));
        var tmp_11 = this;
        var tmp_12 = KMutableProperty1();
        var tmp_13 = TimeFieldContainer$_get_amPm_$ref_u9tt1b();
        tmp_11.m1x_1 = new (GenericFieldSpec())(new (PropertyAccessor())(getPropertyCallableRef('amPm', 1, tmp_12, tmp_13, TimeFieldContainer$_set_amPm_$ref_hgxhkj())));
        var tmp_14 = this;
        var tmp_15 = KMutableProperty1();
        var tmp_16 = TimeFieldContainer$_get_hourOfAmPm_$ref_okyxye();
        tmp_14.n1x_1 = new (UnsignedFieldSpec())(new (PropertyAccessor())(getPropertyCallableRef('hourOfAmPm', 1, tmp_15, tmp_16, TimeFieldContainer$_set_hourOfAmPm_$ref_y4i32())), 1, 12);
      }
    }
    initMetadataForObject($, 'TimeFields');
    TimeFieldsClass = $;
  }
  return TimeFieldsClass;
}
var TimeFields_instance;
function TimeFields_getInstance() {
  if (TimeFields_instance === VOID)
    new (TimeFields())();
  return TimeFields_instance;
}
function ISO_TIME$delegate$lambda() {
  _init_properties_LocalTimeFormat_kt__5i3lfh();
  var tmp = Companion_instance;
  return tmp.d1x(ISO_TIME$delegate$lambda$lambda);
}
function ISO_TIME$delegate$lambda$lambda($this$build) {
  _init_properties_LocalTimeFormat_kt__5i3lfh();
  $this$build.v1q();
  char($this$build, _Char___init__impl__6a9atx(58));
  $this$build.w1q();
  var tmp = [ISO_TIME$delegate$lambda$lambda$lambda];
  alternativeParsing($this$build, tmp, ISO_TIME$delegate$lambda$lambda$lambda_0);
  return Unit_instance;
}
function ISO_TIME$delegate$lambda$lambda$lambda($this$alternativeParsing) {
  _init_properties_LocalTimeFormat_kt__5i3lfh();
  return Unit_instance;
}
function ISO_TIME$delegate$lambda$lambda$lambda_0($this$alternativeParsing) {
  _init_properties_LocalTimeFormat_kt__5i3lfh();
  char($this$alternativeParsing, _Char___init__impl__6a9atx(58));
  $this$alternativeParsing.x1q();
  optional($this$alternativeParsing, VOID, ISO_TIME$delegate$lambda$lambda$lambda$lambda);
  return Unit_instance;
}
function ISO_TIME$delegate$lambda$lambda$lambda$lambda($this$optional) {
  _init_properties_LocalTimeFormat_kt__5i3lfh();
  char($this$optional, _Char___init__impl__6a9atx(46));
  $this$optional.y1q(1, 9);
  return Unit_instance;
}
function _get_ISO_TIME_$ref_kyx2od() {
  return () => get_ISO_TIME();
}
function AmPmMarker_AM_getInstance() {
  AmPmMarker_initEntries();
  return AmPmMarker_AM_instance;
}
function AmPmMarker_PM_getInstance() {
  AmPmMarker_initEntries();
  return AmPmMarker_PM_instance;
}
var properties_initialized_LocalTimeFormat_kt_l1b0w1;
function _init_properties_LocalTimeFormat_kt__5i3lfh() {
  if (!properties_initialized_LocalTimeFormat_kt_l1b0w1) {
    properties_initialized_LocalTimeFormat_kt_l1b0w1 = true;
    ISO_TIME$delegate = lazy(ISO_TIME$delegate$lambda);
    emptyIncompleteLocalTime = new (IncompleteLocalTime())();
  }
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  amPmHour as amPmHour1hvi7u14xj951,
  amPmMarker as amPmMarker15xvjzra6ar5a,
  hour as hour31jxjrzfyqe0i,
  minute as minute2dqmds23fogn6,
  secondFraction as secondFraction17r4cie9ncxw,
  second as secondq4lhw2ppe1iv,
  time as time3kvfctmdykstm,
  AbstractWithTimeBuilder as AbstractWithTimeBuilder2vqnew72ok0ro,
  get_ISO_TIME as get_ISO_TIME31n00f6uljtbs,
  IncompleteLocalTime as IncompleteLocalTime3h4nusjwtlckd,
  TimeFieldContainer as TimeFieldContainer3bsvpq7sk70go,
};
//endregion

//# sourceMappingURL=LocalTimeFormat.mjs.map
